import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for stored auth
    const storedToken = localStorage.getItem("cyberx_token");
    const storedUser = localStorage.getItem("cyberx_user");
    
    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = (userData, authToken) => {
    setUser(userData);
    setToken(authToken);
    localStorage.setItem("cyberx_token", authToken);
    localStorage.setItem("cyberx_user", JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem("cyberx_token");
    localStorage.removeItem("cyberx_user");
  };

  const updateBalance = (newBalance) => {
    if (user) {
      const updatedUser = { ...user, credit: newBalance };
      setUser(updatedUser);
      localStorage.setItem("cyberx_user", JSON.stringify(updatedUser));
    }
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, logout, updateBalance }}>
      {children}
    </AuthContext.Provider>
  );
};
